<template>
  <div class="my-cell-group">
    <van-cell-group>
      <div class="title">基本信息</div>
      <van-cell size="small" title="头像" title-class="justify-lable" center>
        <template>
          <van-image round width="36" height="36" :src="userInfo.imgUrl | imgUrl('user')" class="vertical-middle">
            <template v-slot:error>
              <van-icon size="36" :name="require('../../assets/imgs/default-user-avatar.png')"></van-icon>
            </template>
          </van-image>
        </template>
      </van-cell>
      <van-cell
        title="昵称"
        :value="userInfo.nickName"
        title-class="justify-lable"
        class="min-value-width-168"
        size="small"
      ></van-cell>
    </van-cell-group>
    <br />
    <van-cell-group class="info-input">
      <div class="title">
        <span>患者信息</span>
        <van-button type="primary" :border="false" plain @click="handleToCompleteInfo">完善信息</van-button>
      </div>
      <van-cell
        title="姓名"
        :value="userInfo.name"
        title-class="justify-lable"
        size="small"
      ></van-cell>
      <van-cell
        title="性别"
        :value="userInfo.sex | sex"
        title-class="justify-lable"
        size="small"
      ></van-cell>
      <van-cell
        title="所在地"
        v-model="addressValue"
        title-class="justify-lable"
        class="min-value-width-168"
        size="small"
      ></van-cell>
      <!-- <van-field v-model="addressValue" type="text" label="所在地" readonly @click="showAreaPicker = true" is-link /> -->
      <van-cell
        title="身份证号"
        :value="userInfo.card"
        title-class="justify-lable"
        class="min-value-width-168"
        size="small"
      ></van-cell>
      <van-cell
        title="出生日期"
        :value="userInfo.birthday | parseDate('yyyy-MM-dd')"
        title-class="justify-lable"
        size="small"
      ></van-cell>
    </van-cell-group>
    <br />
    <van-cell-group class="info-input">
      <div class="title">
        <span>设备信息</span>
        <van-button type="primary" :border="false" plain @click="handleToBindMobile">立即绑定</van-button>
      </div>
      <van-cell
        title="手机账号"
        :value="userInfo.mobile"
        title-class="justify-lable"
        size="small"
      ></van-cell>
      <van-cell
        title="微信账号"
        :value="userInfo.isBindWechat ? '已绑定' : '未绑定'"
        title-class="justify-lable"
        size="small"
      ></van-cell>
    </van-cell-group>

    <footer class="footer-btn" @click="goLogOff">注销账号</footer>

    <van-action-sheet
      v-model="editSex"
      :round="false"
      :actions="sexOptions"
      @select="onSelect"
      cancel-text="取消"
    ></van-action-sheet>

    <van-action-sheet v-model="showAreaPicker" :round="false">
      <van-area
        :area-list="areaList"
        columns-num="2"
        @confirm="setAdd"
        @cancel="handleCancel"
        :value="userInfo.districtCode"
      />
    </van-action-sheet>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import addressPicker from '@/mixins/addressPicker.js';

export default {
  name: 'UserInfo',
  mixins: [addressPicker],
  data() {
    return {
      editSex: false,
      sexOptions: [
        { name: '男', code: 1 },
        { name: '女', code: 2 }
      ]
    };
  },
  components: {},
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['addressValue'])
  },

  watch: {},
  methods: {
    ...mapMutations(['updUserInfo']),
    onSelect(data = {}) {
      const params = {
        sex: data.code
      };
      this.saveUserInfo(params);
    },
    saveUserInfo(params) {
      this.$fetch.fetchModifyUserInfo(params).then(() => {
        this.updUserInfo(params);
        this.editSex = false;
      });
    },
    // saveAddress 在mixins addressPicker 里调用
    saveAddress() {
      this.saveUserInfo(this.addressInfo);
    },

    goLogOff() {
      this.$router.push({
        name: 'logOff',
        query: {
          tel: this.userInfo.mobile
        }
      });
    },

    handleToCompleteInfo() {
      this.$router.push({
        name: 'BindingInfo',
        query: { jumpUrl: location.href }
      });
    },

    handleToBindMobile() {
      this.$router.push({
        name: 'UpdMobile',
      });
    }
  }
};
</script>

<style scoped lang="scss">
.my-cell-group {
  ::v-deep.van-cell__flexbox {
    align-items: center;
  }
  ::v-deep.van-cell__value {
    // min-width: 180px;
  }
}
.my-photo {
  vertical-align: middle;
  margin-right: 12px;
}
.info-input > div {
  padding-right: 12px;
  i {
  }
}
.min-value-width-168 {
  ::v-deep .van-cell__flexrow {
    .van-cell__value {
      min-width: 168px;
    }
  }
}
.footer-btn {
  color: #262626;
  font-size: 16px;
  background: #ffffff;
  padding: 18px 16px;
  text-align: center;
  margin: 12px 0;
}

.title {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #262626;
  .van-button {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
